import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OtherService } from "src/app/Service/other.service";
import { map, Observable, of } from 'rxjs';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { Chart, registerables } from 'chart.js';
import { BingMaps, Cluster, OSM, Vector, XYZ } from 'ol/source';
import { Feature, View } from 'ol';
import { MapService } from 'src/app/Service/map.service';
import { Point } from 'ol/geom';
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import zoomPlugin from 'chartjs-plugin-zoom';
import axios from "src/app/Service/axios";
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import TileLayer from 'ol/layer/Tile';
import Map from 'ol/Map';
import AnimatedCluster from 'ol-ext/layer/AnimatedCluster';
import SelectCluster from 'ol-ext/interaction/SelectCluster';
import * as olProj from 'ol/proj';
declare let $: any;


@Component({

  selector: 'app-pre-registration-dashboard',

  templateUrl: './pre-registration-dashboard.component.html',

  styleUrls: ['./pre-registration-dashboard.component.css']

})

export class PreRegistrationDashboardComponent implements OnInit {

  vector: any;

  vector2: any;

  source: any;

  source2: any;

  layers: any = [];

  layers2: any = [];

  ctx1: any;

  ctx2: any;

  ctx3: any;

  ctx4: any;

  ctx5: any;

  ctx6: any;

  ctx7: any;

  ctx8: any;

  obj1: any;

  obj2: any;

  obj3: any;

  obj4: any;

  obj5: any;

  obj6: any;

  label1: Array<any> = [];

  label2: Array<any> = [];

  label3: Array<any> = [];

  label4: Array<any> = [];

  label5: Array<any> = [];

  label6: Array<any> = [];

  datachart1: Array<any> = [];

  datachart2: Array<any> = [];

  datachart3: Array<any> = [];

  datachart4: Array<any> = [];

  datachart5: Array<any> = [];

  datachart6: Array<any> = [];

  options!: Observable<any>;

  CHART_COLORS: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    yellow: 'rgb(251, 101, 150)',
    orange: 'rgb(45, 103, 103)',
    red: 'rgb(35, 123, 45)',
    grey: 'rgb(103, 13, 183)',
  };

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private router: Router,

    private deviceDetector: DeviceDetectorService,

    private otherService: OtherService,

    private gurdService: GurdServiceService,

    private _tooltip: NotificationService,

    private mapService: MapService,

  ) {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);
  }

  ngOnInit() {

    this.initialization();

    Chart.defaults.locale = 'fa-IR';

    Chart.defaults.font.family = 'vazir';

    Chart.defaults.font.size = 13;

  }

  initialization = async () => {

    this.otherService.Showspinner();

    await this.loadTree1('Preregistration_DashboardBaseDomain');

    await this.getInstallationStatus();

    await this.getFloatingType();

    await this.getRegisterDatChart();

    await this.getAnnouncement();

    await this.getInstallerPlanChart();

    await this.getInstallDateChart();

    await this.getPreregistration_Map();

    await this.getInstallMap();

    this.otherService.nonespinner();

  }

  loadTree1 = async (api: any) => {

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };

    this.otherService.Showspinner();

    const resp = await axios.post(`${api}`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    this.options = of(resp.data).pipe(map((data: any) => {

      let res = JSON.parse(data.toString());

      let not = 0;

      res.children.forEach((element: any) => {

        not += element.children.length

      });

      if (not > 50) {

        let can = document.getElementById('totalVehicles') as HTMLElement;

        can.style.height = '700px'

      }

      res.children.forEach(function (datum: any, index: number) {

        index % 1 === 0 && (datum.collapsed = true);

      });

      return {
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          responsive: true,
          textStyle: {
            color: '#000',
            fontFamily: 'vazir',
            fontSize: 12
          },
          formatter: function (params: any) {
            return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
          }
        },
        series: [
          {
            type: 'tree',
            data: [res],
            top: '1%',
            left: '10%',
            responsive: true,
            bottom: '5%',
            right: '20%',
            symbolSize: 10,
            label: {
              position: 'left',
              fontFamily: 'vazir',
              verticalAlign: 'middle',
              align: 'right',
              fontSize: 12,
              fontWeight: 500,
              color: '#000',
            },
            leaves: {
              label: {
                position: 'right',
                verticalAlign: 'middle',
                align: 'left',
                color: '#000'
              },
            },
            expandAndCollapse: true,
            animationDuration: 550,
            animationDurationUpdate: 750,
          },
        ],
      };
    }),
    );

  }

  getInstallationStatus = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`Preregistration_InstallationStatusChart`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this._tooltip.showError(resParse.strError);
      return;

    }

    if (resParse.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '57' } });

      return;
    }

    this.obj1 = resParse;

    this.obj1.forEach((element: any) => {
      this.label1.push(element.X);
      this.datachart1.push(element.Y);
    });
    var canvas = document.getElementById("myChart1") as any;
    var ctx = canvas.getContext("2d");
    const DATA_COUNT = 5;
    const data = {
      labels: this.label1,
      datasets: [
        {
          data: this.datachart1,
          backgroundColor: Object.values(this.CHART_COLORS),
        },
      ],
    } as any;
    if (this.ctx1) {
      this.ctx1.destroy();
    }
    this.ctx1 = new Chart(ctx, {
      type: 'pie',
      data: data,
      options: {
        onClick: (e) => {
          // const points = this.ctx1.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          // const firstPoint = points[0];
          // const label = this.ctx1.data.labels[firstPoint.index];
          // const value = this.ctx1.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          // this.carStatus(1, label);
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              color: "black",
            }
          },
          title: {
            display: false,
          },
        },

      },
    });

    var chartEl = document.getElementById("myChart1") as any;
    chartEl.height = 200;

  }

  getFloatingType = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`Preregistration_FloatingTypeChart`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this._tooltip.showError(resParse.strError);
      return;

    }

    if (resParse.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '57' } });

      return;
    }

    this.obj2 = resParse;

    this.obj2.forEach((element: any) => {
      this.label2.push(element.X);
      this.datachart2.push(element.Y);
    });
    var canvas = document.getElementById("myChart2") as any;
    var ctx = canvas.getContext("2d");
    const DATA_COUNT = 5;
    const data = {
      labels: this.label2,
      datasets: [
        {
          data: this.datachart2,
          backgroundColor: Object.values(this.CHART_COLORS),
        },
      ],
    } as any;
    if (this.ctx2) {
      this.ctx2.destroy();
    }
    this.ctx2 = new Chart(ctx, {
      type: 'pie',
      data: data,
      options: {
        onClick: (e) => {
          // const points = this.ctx2.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          // const firstPoint = points[0];
          // const label = this.ctx2.data.labels[firstPoint.index];
          // const value = this.ctx2.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          // this.carStatus(1, label);
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              color: "black",
            }
          },
          title: {
            display: false,
          },
        },

      },
    });

    var chartEl = document.getElementById("myChart2") as any;
    chartEl.height = 200;

  }

  getRegisterDatChart = async () => {

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    }

    const resp = await axios.post(`Preregistration_RegisterDatChart`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this._tooltip.showError(resParse.strError);
      return;

    }

    if (resParse.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '32' } });

      return;
    }

    this.obj3 = resParse;

    this.label3 = [];

    this.datachart3 = [];

    this.obj3.forEach((element: any) => {
      this.label3.push(element.X);
      this.datachart3.push(element.Y);
    });

    const ctx = document.getElementById('myChart3') as any;

    if (this.ctx3) {
      this.ctx3.destroy();
    }

    this.ctx3 = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.label3,
        datasets: [
          {
            label: 'تعداد',
            data: this.datachart3,
            fill: false,
            borderColor: "#FF3333",
            backgroundColor: "#e755ba",
            pointBackgroundColor: "#990000",
            pointBorderColor: "#990000",
            pointRadius: 4
          },
        ],

      },

      options: {
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "vazir",
                size: 12
              }
            }
          }
        }
      }
    });

  }

  getAnnouncement = async () => {

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    }

    const resp = await axios.post(`Preregistration_AnnouncementDateChart`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this._tooltip.showError(resParse.strError);
      return;

    }

    if (resParse.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '32' } });

      return;
    }

    this.obj4 = resParse;

    this.label4 = [];

    this.datachart4 = [];

    this.obj4.forEach((element: any) => {
      this.label4.push(element.X);
      this.datachart4.push(element.Y);
    });

    const ctx = document.getElementById('myChart4') as any;

    if (this.ctx4) {
      this.ctx4.destroy();
    }

    this.ctx4 = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.label4,
        datasets: [
          {
            label: 'تعداد',
            data: this.datachart4,
            fill: false,
            borderColor: "#FF3333",
            backgroundColor: "#e755ba",
            pointBackgroundColor: "#990000",
            pointBorderColor: "#990000",
            pointRadius: 4
          },
        ],

      },

      options: {
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "vazir",
                size: 12
              }
            }
          }
        }
      }
    });

  }

  getInstallerPlanChart = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`Preregistration_InstallerPlanChart`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this._tooltip.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '21' } });

      return;
    }
    this.obj5 = resParse;
    this.label5 = [];
    this.datachart5 = [];
    this.obj5.forEach((element: any) => {
      this.label5.push(element.X);
      this.datachart5.push(element.Y);
    });
    const ctx = document.getElementById('myChart5') as any;
    if (this.ctx5) {
      this.ctx5.destroy();
    }
    this.ctx5 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label5,
        datasets: [
          {
            label: 'تعداد',
            data: this.datachart5,
            backgroundColor: Object.values(this.CHART_COLORS),

          },
        ],

      },

      options: {
        onClick: (e) => {
          // const points = this.ctx5.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          // const firstPoint = points[0];
          // const label = this.ctx5.data.labels[firstPoint.index];
          // const value = this.ctx5.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];

        },
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });
  }

  getInstallDateChart = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`Preregistration_InstallDateChart`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this._tooltip.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '21' } });

      return;
    }
    this.obj6 = resParse;
    this.label6 = [];
    this.datachart6 = [];
    this.obj6.forEach((element: any) => {
      this.label6.push(element.X);
      this.datachart6.push(element.Y);
    });
    const ctx = document.getElementById('myChart6') as any;
    if (this.ctx6) {
      this.ctx6.destroy();
    }
    this.ctx6 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label6,
        datasets: [
          {
            label: 'تعداد',
            data: this.datachart6,
            backgroundColor: Object.values(this.CHART_COLORS),

          },
        ],

      },

      options: {
        onClick: (e) => {
          // const points = this.ctx5.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          // const firstPoint = points[0];
          // const label = this.ctx5.data.labels[firstPoint.index];
          // const value = this.ctx5.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];

        },
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });
  }

  getPreregistration_Map = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    }

    let res = JSON.parse(((await axios.post(`Preregistration_Map`, model)).data.toString()));

    console.log(res)

    setTimeout(() => {

      if (this.ctx7) this.ctx7.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
      }

      this.ctx7 = new Map({

        target: "Preregistration_Map",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers

      });

      this.clustersLayer(res, model);

    }, 500);

  }

  getInstallMap = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    }

    let res = JSON.parse(((await axios.post(`Preregistration_InstallMap`, model)).data.toString()));

    setTimeout(() => {

      if (this.ctx8) this.ctx8.setTarget(null);

      this.source2 = new VectorSource({ wrapX: false });

      this.vector2 = new VectorLayer({

        source: this.source2,

      });

      if (this.bOfflineMap) {

        this.layers2.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)
      }

      this.ctx8 = new Map({

        target: "InstallMap",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers2

      });

      this.clustersLayer2(res, model);

    }, 500);

  }

  clustersLayer = async (data: any, model: any) => {

    setTimeout(() => {

      this.ctx7.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(
          this.ctx7.getEventPixel(e.originalEvent),
          this.ctx7
        );

        // if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data.strMobile, model)

        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.ctx7.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.ctx7.getView().calculateExtent(this.ctx7.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fLon,
            data[i].fLat])

          ),
          id_: data[i].iPreregistration,
          data: {
            iPreregistration: data[i].iPreregistration,
            strfFullName: data[i].strfFullName,
          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.ctx7.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.ctx7.addInteraction(selectCluster);

  }

  clustersLayer2 = async (data: any, model: any) => {

    setTimeout(() => {

      this.ctx8.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(
          this.ctx8.getEventPixel(e.originalEvent),
          this.ctx8
        );

        // if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data.strMobile, model)

        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.ctx8.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.ctx8.getView().calculateExtent(this.ctx8.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fInstall_Lon,
            data[i].fInstall_Lat])

          ),
          id_: data[i].iPreregistration,
          data: {
            iPreregistration: data[i].iPreregistration,
            strfFullName: data[i].strfFullName,
          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.ctx8.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.ctx8.addInteraction(selectCluster);

  }

}
